import PropTypes from "prop-types";

import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

/**
 * Batch 2.3 — <CategorySelect>. Multi-select over the website's content
 * categories → `category_ids`. The category list is owned by the parent
 * (ContentForm fetches it once and shares it with the type-block fields).
 */
function CategorySelect({ value, onChange, categories }) {
  const handleChange = (event) => {
    const next = event.target.value;
    onChange(typeof next === "string" ? next.split(",") : next);
  };

  return (
    <TextField
      select
      label="Categories"
      value={value}
      onChange={handleChange}
      fullWidth
      disabled={categories.length === 0}
      helperText={categories.length === 0 ? "No categories defined for this website" : undefined}
      SelectProps={{
        multiple: true,
        renderValue: (selected) =>
          categories
            .filter((c) => selected.includes(c.content_category_id))
            .map((c) => c.name)
            .join(", "),
      }}
    >
      {categories.map((category) => (
        <MenuItem key={category.content_category_id} value={category.content_category_id}>
          {category.name}
        </MenuItem>
      ))}
    </TextField>
  );
}

CategorySelect.defaultProps = {
  value: [],
  categories: [],
};

CategorySelect.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(PropTypes.object),
};

export default CategorySelect;
